import { render, staticRenderFns } from "./addFriendlink.vue?vue&type=template&id=1ff3bff5&v-title='%E5%BE%81%E9%9B%86%E8%B5%9E%E5%8A%A9%E5%95%86'&"
import script from "./addFriendlink.vue?vue&type=script&lang=js&"
export * from "./addFriendlink.vue?vue&type=script&lang=js&"
import style0 from "./addFriendlink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports